import { useState, useEffect } from "react";
import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const S = { fontFamily: "'Inter', system-ui, sans-serif" };

export default function StarHavenAdmin() {
  const [codes, setCodes] = useState([]);
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState("");
  const [msg, setMsg] = useState(null);
  const load = async () => {
    const r = await axios.get(`${API}/starhaven/admin/access-codes`);
    setCodes(r.data.codes || []);
  };
  useEffect(() => { load(); }, []);
  const create = async () => {
    setMsg(null);
    try {
      const r = await axios.post(`${API}/starhaven/admin/access-codes`,
        { customer_email: email, shopify_order_id: order || null });
      setMsg(`Created ${r.data.code}`); setEmail(""); setOrder(""); load();
    } catch (e) { setMsg(e?.response?.data?.detail || "Error"); }
  };
  const voidCode = async (c) => { await axios.post(`${API}/starhaven/admin/access-codes/${c}/void`); load(); };
  const inp = { ...S, padding: "9px 12px", border: "1px solid #E3D8CC", borderRadius: 8, marginRight: 8, fontSize: 14 };
  return (
    <div style={{ ...S, background: "#F8F5F1", minHeight: "100vh", padding: "40px 24px", color: "#3F332E" }}>
      <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 32 }}>Star Haven · Access Codes</h1>
      <p style={{ color: "#6A5A50", fontSize: 14 }}>Manual admin fallback. Uses the same code-creation path a Shopify webhook will use later.</p>
      <div style={{ margin: "18px 0" }}>
        <input data-testid="admin-email" style={inp} placeholder="customer email" value={email} onChange={(e) => setEmail(e.target.value)} />
        <input data-testid="admin-order" style={inp} placeholder="shopify order id (optional)" value={order} onChange={(e) => setOrder(e.target.value)} />
        <button data-testid="admin-create" onClick={create} disabled={!email}
          style={{ ...S, padding: "9px 18px", background: "#BF826A", color: "#FBF8F3", border: "none", borderRadius: 999, cursor: "pointer" }}>Create code</button>
        {msg && <span style={{ marginLeft: 12, color: "#A96F5D" }}>{msg}</span>}
      </div>
      <table style={{ ...S, width: "100%", borderCollapse: "collapse", fontSize: 13 }} data-testid="admin-table">
        <thead><tr style={{ textAlign: "left", color: "#6A5A50" }}>
          {["code","email","order","status","redeemed_at","chart_id",""].map((h) => <th key={h} style={{ padding: 8, borderBottom: "1px solid #E3D8CC" }}>{h}</th>)}
        </tr></thead>
        <tbody>{codes.map((c) => <tr key={c.code} style={{ borderBottom: "1px solid #EFE4D8" }}>
          <td style={{ padding: 8, fontFamily: "monospace" }}>{c.code}</td>
          <td style={{ padding: 8 }}>{c.customer_email}</td>
          <td style={{ padding: 8 }}>{c.shopify_order_id || "—"}</td>
          <td style={{ padding: 8 }}>{c.status}</td>
          <td style={{ padding: 8 }}>{c.redeemed_at ? c.redeemed_at.slice(0,10) : "—"}</td>
          <td style={{ padding: 8, fontFamily: "monospace", fontSize: 11 }}>{c.chart_id ? c.chart_id.slice(0,8) : "—"}</td>
          <td style={{ padding: 8 }}>{c.status !== "void" && <button onClick={() => voidCode(c.code)} style={{ ...S, cursor: "pointer", border: "1px solid #A8874F", background: "transparent", borderRadius: 6, padding: "4px 10px" }}>void</button>}</td>
        </tr>)}</tbody>
      </table>
    </div>
  );
}
